// src/pages/Dashboard.jsx
import { useNavigate } from 'react-router-dom';

const Elibrary = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-100">
      <h1 className="text-4xl font-bold mb-8 text-gray-800">📚 E-Library Dashboard</h1>

      <div className="flex space-x-6">
        <button
          onClick={() => navigate('/elibrary/create')}
          className="bg-blue-600 text-white px-6 py-3 rounded-md text-lg hover:bg-blue-700 transition"
        >
          Create
        </button>
        <button
          onClick={() => navigate('/elibrary/update')}
          className="bg-green-600 text-white px-6 py-3 rounded-md text-lg hover:bg-green-700 transition"
        >
          Update
        </button>
      </div>
    </div>
  );
};

export default Elibrary;
